/**
 * Scroll a message thread so the latest messages are in view.
 * Uses double rAF so layout/max-height are applied before measuring.
 * @param {HTMLElement | null | undefined} node
 */
export function scrollMessageThreadToLatest(node) {
  if (!node) return;
  const scroll = () => {
    node.scrollTop = node.scrollHeight;
  };
  scroll();
  if (typeof requestAnimationFrame !== 'function') return;
  requestAnimationFrame(() => {
    scroll();
    requestAnimationFrame(scroll);
  });
}
